document.addEventListener('click', async function(e) {
  const btn=e.target.closest('#CartDrawer .nuvoza-upsell-add');
  if (!btn || btn.disabled) return;
  const id=Number(btn.dataset.variantId); if(!id) return;
  btn.disabled=true; btn.textContent='TOEVOEGEN…';
  try {
    const res=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})
    });
    if(!res.ok) throw new Error('Unable to add');
    window.location.reload();
  } catch(err) {btn.disabled=false;btn.textContent='PROBEER OPNIEUW';}
});